import { Card, CardContent, CircularProgress, Divider, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import FgsCallSondaj from '../Overview/FgsCallSondaj';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import React from 'react';
import RoomIcon from '@material-ui/icons/Room';
import logger from 'src/utils/logger';

const useStyles = makeStyles(() => ({
  root: {},
}));


function CentralPaper({ className, items, Loading, handleOpenDetail }) {
  const classes = useStyles();
  const [openFgsArama, setOpenFgsArama] = React.useState(false);
  const [fisno, setFisNo] = React.useState('');
  const [Telefon, setTelefon] = React.useState('');
  const [Telefon2, setTelefon2] = React.useState('');
  const handleFgsAramaOpen = (event, AtananIsFisNo,Tel1,Tel2) => {
    setTelefon(Tel1)
    setTelefon2(Tel2);
    setFisNo(AtananIsFisNo.toString());
    setOpenFgsArama(true);

  }
  const handleFgsAramaClose = () => {
    setOpenFgsArama(false);
  }
 const handleClick = (event, enlem, boylam) => {
    event.preventDefault(); // Varsayılan davranışı durdur
    const mapUrl = process.env.REACT_APP_MAP_URL || "https://www.google.com/maps/search/?api=1&query=";
    
    // Güvenli pencere açma
    try {
      const win = window.open(mapUrl + enlem + "," + boylam, '_blank');
      if (win) win.focus();
    } catch (e) {
      logger.error("Harita açılamadı:", e);
    }
  };
  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          <div className={classes.inner}>
            {Loading ?
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }}
              />
              :
              <List className={classes.root}>
                {items.map(Data =>
                  <div>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar key={Data.FIS_NO}>
                        <Typography
                          component="span"
                          variant="h3"
                          className={classes.inline}
                          color="textPrimary">{Data.GUN}</Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{Data.AY}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{Data.YIL}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="caption"
                          className={classes.inline}
                          color="textPrimary">{Data.SAAT}
                        </Typography>
                        <br />
                      </ListItemAvatar>
                      <ListItemText
                        primary={Data.FIS_NO + ' ' + Data.ADI + ' ' + Data.SOYADI}
                        secondary={
                          <React.Fragment>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                            </Typography>
                            <Typography
                              component="span"
                              variant="body2"
                              color="textPrimary"
                            >
                              {Data.DURUM}
                            </Typography>
                            {Data.SONDAJ_VARMI ?
                              <Typography
                                component="span"
                                variant="body2"
                                color="textPrimary"
                              >
                                <b>   Sondaj girişi var.</b>
                              </Typography>
                              :
                              <Typography
                                component="span"
                                variant="body2"
                                color="textPrimary"
                              >
                                <b>    Sondaj girişi yok.</b>
                              </Typography>
                            }
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {Data.SERVIS_KODU} {Data.SERVIS}
                            </Typography>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {Data.BASVURU_NEDENI}
                            </Typography>
                            <Typography
                              component="span"
                              variant="body2"
                              color="textPrimary"
                            >
                              {Data.KUL_MODEL_KODU} {Data.MODEL}
                            </Typography>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {Data.TEL1} {Data.TEL2}
                            </Typography>
                            <Grid item xs={12} >
                              <PhoneInTalkIcon
                                align="left"
                                color="secondary"
                                onClick={(event) => handleFgsAramaOpen(event, Data.FIS_NO, Data.TEL1, Data.TEL2)}
                                disabled={1} >
                              </PhoneInTalkIcon>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;


                              <RoomIcon align='right' color="secondary" onClick={(event) => handleClick(event, Data.ENLEM, Data.BOYLAM)}></RoomIcon>


                            </Grid>



                          </React.Fragment>

                        }
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="Detayları Göster">
                          <IconButton
                            color="primary"
                            onClick={() => handleOpenDetail(Data)}
                            edge="end"
                            size="small">
                            <ArrowForwardIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </div>
                )}
              </List>
            }
          </div>
          <FgsCallSondaj
            onClose={handleFgsAramaClose}
            FisNo={fisno}
            Telefon={Telefon}
            Telefon2={Telefon2}
            open={openFgsArama}
          />
        </CardContent>
      </Card>
    </div >
  );
}

CentralPaper.propTypes = {
  className: PropTypes.string
};

export default CentralPaper;
